import { UOM_TO_DESCRIPTION } from "routes/schedule/lib/uom-to-input"
import { Editable } from "lib/@components/editable"
import { SummaryDataChanged } from "event-definitions"
import { HighlightBox } from "lib/@components/highlightBox"
import { Box, Tooltip } from "@mui/material"
import { BoundPopup } from "lib/@components/combos/boundPopup"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTranslationContext } from "routes/schedule/plugins/translation/use-translation-context"
import { Frag } from "lib/@components/slot/frag"
import { LocalizedMessage } from "lib/localization/localized-message"

export function UnitLabel({ defaultUnitOfMeasure }) {
    const { target, editMode, mustShowContent, inComparison } = useBoundContext()
    const { translatedSkills } = useTranslationContext()
    const unitOfMeasure = target.unitOfMeasure ?? defaultUnitOfMeasure
    const editableWidth = getEditableWidth({
        editMode,
        mustShowContent,
        inComparison,
        unitOfMeasure,
    })

    return (
        <Box ml={1} className="uom" data-comment-part="uom" flex={1}>
            <Editable
                sx={{
                    width: editableWidth,
                }}
                pt={1}
                pb={1}
                editor={
                    <EditUnitLabel>
                        {UOM_TO_DESCRIPTION[target.unitOfMeasure ?? defaultUnitOfMeasure] ?? ""}
                    </EditUnitLabel>
                }
            >
                <Frag>
                    {(target.unitOfMeasure !== "Nr" || editMode || mustShowContent || inComparison) && (
                        <Box pt={0} lineHeight={0} mt={-0.5}>
                            <Tooltip
                                arrow
                                title={
                                    translatedSkills?._unitOfMeasureTooltip ?? (
                                        <LocalizedMessage template="The unit of measurement for this task" />
                                    )
                                }
                            >
                                <HighlightBox path="unitOfMeasure">
                                    {UOM_TO_DESCRIPTION[target.unitOfMeasure] ?? ""}
                                </HighlightBox>
                            </Tooltip>
                        </Box>
                    )}
                </Frag>
            </Editable>
        </Box>
    )
}

function getEditableWidth({ editMode, mustShowContent, inComparison, unitOfMeasure }) {
    if (editMode || mustShowContent || inComparison) return 100
    if (unitOfMeasure !== "Nr") return "70px"
    return "0px"
}

function EditUnitLabel({ children, onClick }) {
    return (
        <BoundPopup
            label="UoM"
            onChanged={SummaryDataChanged.raiseOnce}
            aria-label="Unit of measure"
            data-cy="unit-of-measure-control"
            field="unitOfMeasure"
            options={UOM_TO_DESCRIPTION}
            onClick={onClick}
        >
            {children}
        </BoundPopup>
    )
}
